import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    devices: translate({ id: 'global.devices' }),
    notToday: translate({ id: 'globalStyles.devices.notToday' }),
    noDevices: translate({ id: 'globalStyles.devices.noDevices' }),
    onWithLabel: translate({ id: 'globalStyles.devices.onWithLabel' }),
  }))

  return api
}
